import { gql } from "@apollo/client";

export const UNASSIGN_PERSON_MUTATION = gql(/* GraphQL */ `
  mutation UnassignStudentPersons($studentId: UUID!, $personIds: [UUID!]!) {
    unassignStudentPersons(
      input: { studentId: $studentId, personIds: $personIds }
    ) {
      student {
        id
        id
        dob
        email
        firstName
        lastName
        gradeLevel
        postalCode
        middleName
        studentCustomFields {
          customField {
            id
            type
            name
          }
          value
        }
        sessions {
          id
          notes {
            body
            id
            data
          }
          riskRating
          status
          createdAt
        }
        persons {
        edges{
        cursor
        node{
        firstName
          lastName
          id
          role {
            name
            normalizedName
          }
        }}
          
        }
        lastSession {
          id
          checkpoint {
            current {
              name
            }
          }
          status
          summary {
            id
            livingSituation
            numberOfSiblings
            peopleCountedOn
            livesMainlyWith
          }
        }
        avatars {
          id
          bodyId
          bodyColor
          eyeColor
          hairColor
          helperId
          shirtColor
          pantsColor
          shoesColor
        }
      }
    }
  }
`);
